// extracted by mini-css-extract-plugin
export default {"container":"Container_container__UKpj0","home":"Container_home__fg3pL"};